import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { MenuItem, MenuListItem } from 'client/bundles/types';
import './index.css';

const b = cn('site-menu');

interface Props {
    items: MenuListItem[];
}

interface State {
    indexSectionOpened?: number;
}

class SiteMenu extends Component<Props, State> {
    private root = React.createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    private get items() {
        const { items } = this.props;

        return items.map(section => {
            return {
                ...section,
                items: section.items?.filter(item => item.visible)
            };
        });
    }

    componentDidMount(): void {
        window.addEventListener('mouseup', this.checkIfClickedOutside);
    }

    componentWillUnmount(): void {
        window.removeEventListener('mouseup', this.checkIfClickedOutside);
    }

    checkIfClickedOutside = (e: Event): void => {
        const { indexSectionOpened } = this.state;

        // Меню отрыто и клик пришелся не в меню
        if (
            indexSectionOpened !== undefined &&
            this.root.current &&
            e.target instanceof Node &&
            !this.root.current.contains(e.target)
        ) {
            this.setState({ indexSectionOpened: undefined });
            // Чтобы не сработал какой-нибудь клик, если пользователь попал на ссылку в документе
            e.preventDefault();
        }
    }

    toggleSection = (index: number) => () => {
        const { indexSectionOpened } = this.state;

        this.setState({
            indexSectionOpened:
                indexSectionOpened === index ? undefined : index
        });
    }

    renderItems = (item: MenuItem, index: number): React.ReactNode => {
        const { isCurrent, url, title, icon, openNewTab } = item;

        return (
            <li key={index} className={b('section-item')}>
                <a
                    className={b('section-link', { active: isCurrent })}
                    href={url}
                    target={openNewTab ? '_blank' : undefined}
                    >
                    {title}
                    {icon && <span className={b('section-icon')} dangerouslySetInnerHTML={{ __html: icon }} />}
                </a>
            </li>
        );
    }

    renderButton = ({ isCurrent, title }: MenuListItem, index: number): React.ReactNode => {
        const { indexSectionOpened } = this.state;

        return (
            <button
                type="button"
                className={b('link', { active: isCurrent })}
                onClick={this.toggleSection(index)}
                aria-haspopup="true"
                aria-expanded={indexSectionOpened === index}
                >
                <span className={b('title-text')}>{title}</span>
                <span className={b('title-control')} />
            </button>
        );
    }

    renderLink = (item: MenuListItem) => {
        return (
            <a href={item.url} className={b('link', { active: item.isCurrent, urgent: item.urgent })} key={item.id}>
                {item.title}
            </a>
        );
    }

    renderSection = (item: MenuListItem, index: number): React.ReactNode => {
        const { indexSectionOpened } = this.state;
        const { items = [] } = item;

        return (
            <li
                key={index}
                className={b('list-item', {
                    opened: indexSectionOpened === index
                })}
                >
                {items.length > 0 ? (
                    <>
                        {this.renderButton(item, index)}
                        <ul className={b('section')}>
                            {items.map(this.renderItems)}
                        </ul>
                    </>) : this.renderLink(item)
                }
            </li>
        );
    }

    render() {
        if (!this.items || this.items.length === 0) {
            return null;
        }

        return (
            <nav className={b()} ref={this.root}>
                <div className={b('inner')}>
                    <ul className={b('nav')}>
                        {this.items.map(this.renderSection)}
                    </ul>
                </div>
            </nav>
        );
    }
}

export default SiteMenu;
